import moment from 'moment-timezone'

import {
  NEXT_3_DAYS,
  NEXT_5_DAYS,
  THIS_WEEK,
  NEXT_WEEK,
  SPECIFIC_DATES
} from './constants'

export const formattedAvailableDays = (data) => (
  Object.fromEntries(
    data
      .days
      .filter((day) => day.spots.length > 0)
      .map((day) => [
        day.date,
        day.spots
          .filter((spot) => spot.status === 'available')
          .map((spot) => spot.startTime)
      ])
  )
)

export const getAvailabilityDateRange = (nextAvailability, availabilityOption, currentMonthId) => {
  if (!nextAvailability) return {}

  let startDate
  let endDate

  switch (availabilityOption) {
    case NEXT_3_DAYS:
    case NEXT_5_DAYS:
      startDate = moment(nextAvailability).startOf('day')
      endDate = startDate.clone().add(2, 'weeks')
      break
    case THIS_WEEK:
      startDate = moment().startOf('week')
      endDate = moment().endOf('week')
      break
    case NEXT_WEEK:
      startDate = moment().startOf('week').add(1, 'week')
      endDate = moment().endOf('week').add(1, 'week')
      break
    case SPECIFIC_DATES:
      startDate = moment(currentMonthId).startOf('month')
      endDate = moment(currentMonthId).endOf('month')
      break
    default:
      break
  }

  startDate = startDate?.format('YYYY-MM-DD')
  endDate = endDate?.format('YYYY-MM-DD')

  return { startDate, endDate }
}

export const getTimeSlotsForDays = (availabilityOption, availableDays) => {
  switch (availabilityOption) {
    case NEXT_3_DAYS:
      return Object.fromEntries(
        Object.keys(availableDays).slice(0, 3).map((date) => [
          date,
          availableDays[date].slice(0, 6)
        ])
      )
    case NEXT_5_DAYS:
      return Object.fromEntries(
        Object.keys(availableDays).slice(0, 5).map((date) => [
          date,
          availableDays[date].slice(0, 6)
        ])
      )
    case THIS_WEEK:
    case NEXT_WEEK:
    case SPECIFIC_DATES:
    default:
      return Object.fromEntries(
        Object.keys(availableDays).map((date) => [
          date,
          availableDays[date].slice(0, 6)
        ])
      )
  }
}

export const reorderDays = (days) => days.sort((a, b) => (moment(a.date).isAfter(b.date) ? 1 : -1))

const hasAvailabilityInDateRange = (availableDays, startDate, endDate) => {
  if (!availableDays || Object.keys(availableDays).length === 0) return false

  const start = moment(startDate)
  const end = moment(endDate)

  return Object.keys(availableDays).some((date) => {
    const currentDate = moment(date)
    return currentDate.isBetween(start, end, 'day', '[]') && availableDays[date].length > 0
  })
}

export const hasThisWeekAvailability = (availableDays, timezone = 'UTC') => {
  const startOfWeek = moment().tz(timezone).startOf('week').format('YYYY-MM-DD')
  const endOfWeek = moment().tz(timezone).endOf('week').format('YYYY-MM-DD')

  return hasAvailabilityInDateRange(availableDays, startOfWeek, endOfWeek)
}

export const hasNextWeekAvailability = (availableDays, timezone = 'UTC') => {
  const startOfNextWeek = moment().tz(timezone).startOf('week').add(1, 'week')
    .format('YYYY-MM-DD')
  const endOfNextWeek = moment().tz(timezone).endOf('week').add(1, 'week')
    .format('YYYY-MM-DD')

  return hasAvailabilityInDateRange(availableDays, startOfNextWeek, endOfNextWeek)
}
